export const PLAYER_PROFILE = {
	allProducts: "all-products",
	sportsbookOnly: "sportsbook-only",
	casinoOnly: "casino-only",
};
